import { useCampaignCode } from '@campaign-services/hooks/useCampaignCode'
import { useApiCampaignActivityInfo } from '@hooks-api/fortune/useApiCampaignActivityInfo'
import { type ChildOrder } from '@hooks-api/types/dataModel/fpOrder'
import { Image } from '@pets-ui/Image/Image'
import { VStack } from '@pets-ui/VStack/VStack'
import { OrderItems } from './order-items'

interface Props {
  projectCode: string
  childOrders: ChildOrder[]
}
export const OrderCard = (props: Props) => {
  const { projectCode, childOrders } = props
  const { campaignCodeFromUrl } = useCampaignCode()
  const { destructuredData: exhibitorSettings } = useApiCampaignActivityInfo(campaignCodeFromUrl)

  const project = exhibitorSettings?.brand_codes_info.find(brand => brand.brand_code === projectCode)

  return (
    <VStack alignItems="center" width="100%" gap={2}>
      <Image src={project?.brand_image} alt={project?.brand_name} width={120} />
      {childOrders.map((order) => {
        return <OrderItems key={order.id} childOrder={order} />
      })}
    </VStack>
  )
}
